import React,{useEffect,useState} from 'react';
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import ReplayIcon from '@material-ui/icons/Replay';
import DoneIcon from '@material-ui/icons/Done';
import {Styles} from './Styles';
import {Inc} from './Inc';
import HaikuShow from './HaikuShow';
import ModalHead from './ModalHead';
import Ajax from './Ajax';
import Loading from './Loading';

interface Props {
    //staff:Staff,
    userId: string,
    close():void,
}

let lists:{[key:number]:string[]} = {0:[],1:[],2:[]};
let choiced:string[] = [];
let isHaikuLock = false;

const Haiku = (props:Props)=> {
    Ajax.setUserId(props.userId);
    const classes = Styles.base();
    const [step,setStep] = useState(0);
    const [song,setSong] = useState(Inc.defaultSong());

    const load = ()=>{
        Ajax.send("kuset/get",{typeId:"2"},(res:any)=>{
            if( res.ok ){
                lists[0] = res.set1;
                lists[1] = res.set2;
                lists[2] = res.set3;
                choiced = [];
                setStep(1);
            }
        })
    }
    const choice = (index:number)=>{
        choiced.push( lists[step-1][index] );
        setStep(step+1);
    }
    const choices = ()=>{
        if( step<1 || step>3 ){
            return (null);
        }
        if( lists[step-1] && lists[step-1].length===0 ){
            return (null);
        }
        return lists[step-1].map( (words,index)=>{
            const key = "words"+index;
            return (
                <Button
                    key={key}
                    variant="contained"
                    className={classes.haikuChoiceButton}
                    onClick={()=>choice(index)}
                    color="primary"
                >{words}</Button>
            )
        })
    }
    const yesno = ()=>{
        return (
            <React.Fragment>
            <div className={classes.upperButtons}>
                <Fab color="primary" size="small" aria-label="No" className={classes.no} onClick={no}>
                    <ReplayIcon/>
                </Fab>
                <Fab color="primary" aria-label="done" className={classes.yes} onClick={yes}>
                    <DoneIcon/>
                </Fab>
            </div>
            </React.Fragment>
        );
    }
    const yes = ()=>{
        if( isHaikuLock ){
            return;
        }
        isHaikuLock = true;
        Ajax.send("haiku/add",{choiced:choiced.join("\t")},(res:any)=>{
            //console.log(res);
            if( res.ok ){
                setSong(res.song)
            }
            isHaikuLock = false;
        })        
    }
    const no = ()=>{
        load();
    }
    const next = ()=>{
        setSong(Inc.defaultSong());
        load();
    }
    useEffect( ()=>{
        load();
    },[]);

    let isLoading = false;
    if( step===0 ){
        isLoading = true;
    }

    if( song.id>0 ){
        return (
            <HaikuShow next={next} song={song} userId={props.userId} close={props.close}/>
        )
    }

	return (
		<div id="haiku">
            <ModalHead close={props.close}/>
            <div className={classes.modalRoot}>
            <div className={classes.choiced}>
                {choiced.length>0 ? (
                    choiced.map((words,index)=>{
                        const key = "choiced"+index;
                        return (
                            <div key={key} className={classes.newline}>{words}</div>
                        )
                    })
                ):(
                    <div className={classes.guide}>5-7-5</div>
                )}
            </div>
            {step<4 ? (
                <div className={classes.buttons}>{choices()}</div>
            ):(
                <div>{yesno()}</div>
            )}
            </div>
            <Loading isLoading={isLoading}/>
		</div>
	);
}

export default Haiku;
